import isWebOsAppSuspended from './detectWebOsSuspendedApp';

export function isLoadedInSoundSource(soundUrl) {
	return Screen.soundSource.hasSoundLoaded(soundUrl);
}

export function playSoundFromSoundSource(soundUrl, playCount, done, onEnded) {
	if (!isLoadedInSoundSource(soundUrl)) {
		log('Audio not in source', soundUrl);
		done?.();
	}

	const play = (times) => {
		const callback = times > 0 ? () => {
			onEnded?.();
			log('Audio in sound source mode from executor ended');
			times > 1 && !isWebOsAppSuspended() ? play(times - 1) : done?.();
		} : null;
		Screen.soundSource.start(soundUrl, callback);
	};

	try {
		play(playCount);
	} catch (ex) {
		log('Sound source error', ex);
		Screen.logErrorToSentry(ex);
		done?.();
	}

	return () => {
		Screen.soundSource.clearEvents();
		Screen.soundSource.stopAll();
		done?.();
	};
}
